import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';
import { AppConfigService } from './app-config.service';
import { DocInfo } from '../models/doc-info.model';

@Injectable({
	providedIn: 'root'
})
export class AdminDownloadService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  getDocInfo(id: string): Observable<DocInfo> {
    const docInfoUrl = `${this.appConfigService.getConfig().webApi}/api2/DocInfo/${id}`;
    return this.http.get<DocInfo>(docInfoUrl);
  }

  postFileList(fileIds: Array<string>): Observable<any> {

    const zipFileListUrl = `${this.appConfigService.getConfig().webApi}/api2/DocDownload`;

    const headers = new HttpHeaders({
      'Accept': 'application/zip'
    });

    // Casting blob to json is a workaround as Typescript needs to infer the Observable and responseType values
    // statically.  See https://github.com/angular/angular/issues/18586 for a much longer-winded explanation.
    return this.http.post<Blob>(zipFileListUrl, fileIds, { headers: headers, responseType: 'blob' as 'json' })
      .pipe(
        map(data => {
          const blob = new Blob([data],
            {
              type: 'application/zip'
            });
          const filename = 'ZipFile.zip';
          FileSaver.saveAs(blob, filename);
        }
        )
      )
      .pipe(
        catchError(this.errorHandler.handleError<Blob>(`${zipFileListUrl} with fileIds ${fileIds}`))
      );
  }
}
